import * as React from 'react';

import { Grid } from '@coursera/cds-core';

import EnterpriseMobileSearchBarLegacyGridItem from 'bundles/composable-page-header-enterprise/components/EnterpriseMobileSearchBarLegacyGridItem';
import { useEnterpriseMyPageHeader } from 'bundles/composable-page-header-enterprise/contexts/EnterpriseMyPageHeaderContext';
import DefaultEnterpriseLoggedOutMobileMenuConfig from 'bundles/composable-page-header-enterprise/module-renderers/DefaultEnterpriseLoggedOutMobileMenuConfig';
import { getLinkForEnterpriseProgram } from 'bundles/composable-page-header-enterprise/utils/enterpiseLogoUtils';
import MainNavigationWrapper from 'bundles/composable-page-header/components/MainNavigationWrapper';
import CourseraHomeLogo from 'bundles/composable-page-header/components/grid-items/home-logo/CourseraHomeLogo';
import HomeLogoGridItemModule from 'bundles/composable-page-header/components/grid-items/home-logo/HomeLogoGridItemModule';
import MobileMenuIconGridItem from 'bundles/composable-page-header/components/grid-items/mobile/MobileMenuIconGridItem';
import { LOGO_WIDTH } from 'bundles/composable-page-header/components/program-switcher/ProgramCard';
import EnterpriseLogo from 'bundles/page-header/components/EnterpriseLogo';

export default function EnterpriseMobileLoggedOutMainNav() {
  const { currentPageProgram } = useEnterpriseMyPageHeader();

  return (
    <MainNavigationWrapper>
      <Grid item xs={8} sm={6} container alignItems="center">
        <MobileMenuIconGridItem
          menuConfig={<DefaultEnterpriseLoggedOutMobileMenuConfig />}
          homeLogo={
            <HomeLogoGridItemModule
              href={getLinkForEnterpriseProgram(currentPageProgram)}
              logos={[
                <CourseraHomeLogo key="1" />,
                <EnterpriseLogo
                  key="2"
                  preferRectangle={false}
                  thirdPartyOrganization={currentPageProgram?.naptimeThirdPartyOrganization}
                  program={{ name: currentPageProgram?.name, metadata: { squareLogo: currentPageProgram?.squareLogo } }}
                  logoWidth={LOGO_WIDTH}
                />,
              ]}
            />
          }
        />
        <HomeLogoGridItemModule
          href={getLinkForEnterpriseProgram(currentPageProgram)}
          logos={[
            <CourseraHomeLogo key="1" />,
            <EnterpriseLogo
              key="2"
              preferRectangle={false}
              thirdPartyOrganization={currentPageProgram?.naptimeThirdPartyOrganization}
              program={{ name: currentPageProgram?.name, metadata: { squareLogo: currentPageProgram?.squareLogo } }}
              logoWidth={LOGO_WIDTH}
            />,
          ]}
        />
      </Grid>
      <Grid item container xs={4} sm={6} alignItems="center" justifyContent="flex-end">
        <EnterpriseMobileSearchBarLegacyGridItem />
      </Grid>
    </MainNavigationWrapper>
  );
}
